import script from "./CpePlatformSearch.vue?vue&type=script&lang=ts&setup=true"
export * from "./CpePlatformSearch.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__